import { useMemo, type FC } from "react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

export const Title: FC<{
  title: string;
  className?: string;
  hideDot?: boolean;
}> = ({ title, className, hideDot }) => {
  const { i18n } = useTranslation();
  console.info(" i18n.language", i18n.language);

  const style = useMemo(() => {
    switch (i18n.language) {
      case "ja":
        return {
          fontWeight: "bold",
        };
      case "zh-CN":
      case "en":
      default:
        return {};
    }
  }, [i18n.language]);

  return (
    <div
      className={twMerge(
        "min-h-6 leading-6 flex justify-center items-center w-full gap-3 text-[18px] text-center px-6",
        className,
      )}
      style={style}
    >
      {!hideDot && (
        <span className="size-1 shrink-0 rounded-full bg-[rgba(127,114,101,1)]" />
      )}
      {title}
      {!hideDot && (
        <span className="size-1 shrink-0 rounded-full bg-[rgba(127,114,101,1)]" />
      )}
    </div>
  );
};
